'use strict';

/* globals yith_wcaf, yith */

import { $ } from '../../../src/globals.js';
import { initFields } from './fields';

export default class YITH_WCAF_Admin_Modal {
	// modal opener
	$opener = null;

	// target of the open event
	$target = null;

	// modal object
	modal = null;

	// fields validator
	validator = null;

	// template variables.
	args = null;

	constructor( $opener, args ) {
		if ( ! $opener?.length || 'undefined' === typeof yith?.ui?.modal ) {
			return;
		}

		this.$opener = $opener;
		this.args = $.extend(
			{
				title: '',
				content: false,
				footer: false,
				showClose: true,
				width: 500,
				onCreate: false,
				onClose: false,
				shouldOpen: null,
				template: false,
				titleTemplate: false,
				data: false,
				classes: {
					wrap: 'yith-wcaf-modal',
				},
			},
			args || {}
		);

		this.init();
	}

	// setters

	addOpeners( $newOpeners ) {
		this.$opener = this.$opener.add( $newOpeners );
		this.reinit();
	}

	// init methods

	init() {
		this.$opener.on( 'click', ( ev ) => {
			this.$target = $( ev.target );

			if ( ! this.shouldOpen() ) {
				return;
			}

			ev.preventDefault();
			this.onOpen();
		} );
	}

	reinit() {
		this.$opener.off( 'click' );
		this.init();
	}

	initFields() {
		const self = this,
			$fields = this.getFields();

		// init fields values.
		$fields.filter( '[data-value]' ).each( function () {
			const $field = $( this ),
				value = $field.data( 'value' );

			if (
				$field.is( 'input[type="checkbox"]' ) ||
				$field.is( 'input[type="radio"]' )
			) {
				if ( 'boolean' === typeof value ) {
					$field.prop( 'checked', value );
				} else if ( value ) {
					$field.prop( 'checked', value === $field.val() );
				} else {
					$field.prop( 'checked', false );
				}
			} else if ( $field.is( 'select' ) && Array.isArray( value ) ) {
				$field.val( value );
			} else if ( $field.is( 'select' ) && 'object' === typeof value ) {
				for ( const i in value ) {
					if ( ! $field.find( `[value="${ i }"]` )?.length ) {
						$field.append(
							$( '<option/>', {
								value: i,
								text: value[ i ],
							} )
						);
					}
				}

				$field.val( Object.keys( value ) );
			} else if ( 'boolean' === typeof value ) {
				$field.val( value ? 1 : 0 );
			} else if ( value ) {
				$field.val( String( value ) );
			}

			$field.trigger( 'change' );
		} );

		// init custom fields handling
		initFields( this.modal.elements.content );
	}

	initSubmit() {
		const $content = this.modal.elements.content,
			$form = $content.find( 'form' );

		$form.on( 'submit', this.onSubmit.bind( this ) );
	}

	// events handling

	getData() {
		let data = this.args?.data || {};

		if ( 'function' === typeof data ) {
			data = data.call( this );
		}

		return data;
	}

	shouldOpen() {
		if ( 'function' === typeof this.args?.shouldOpen ) {
			return this.args.shouldOpen.call( this );
		}

		return true;
	}

	onOpen() {
		let args = { ...this.args },
			template = args?.template || '',
			titleTemplate = args?.titleTemplate || '',
			data = this.getData();

		if ( template ) {
			args.content = wp.template( template )( data );
		} else if ( 'function' === typeof args?.content ) {
			args.content = args.content.call( this, data );
		}

		if ( titleTemplate ) {
			args.title = wp.template( titleTemplate )( data );
		} else if ( 'function' === typeof args?.title ) {
			args.title = args.title.call( this, data );
		}

		this.modal = yith.ui.modal( args );

		// init enhanced selects
		$( document.body ).trigger( 'wc-enhanced-select-init' );

		// trigger additional functionalities
		this.initFields();

		// trigger submit handling.
		this.initSubmit();
	}

	beforeSubmit() {
		return true;
	}

	onSubmit() {
		if ( ! this.beforeSubmit() ) {
			return false;
		}

		if ( 'function' === typeof this.args?.onSubmitSuccess ) {
			this.args?.onSubmitSuccess();
		}
	}

	// fields handling

	getField( fieldName ) {
		return this.getFields().filter( `[name="${ fieldName }"]` ).first();
	}

	getFields() {
		const $content = this.modal.elements.content;

		return $content
			.find( ':input' )
			.not( 'button, input[type="submit"], .select2-search__field' );
	}

	serialize() {
		const $fields = this.getFields();

		let data = {};

		$fields.get().reduce( ( a, field ) => {
			const $field = $( field );

			let value;

			if ( $field.is( 'input[type="checkbox"]' ) ) {
				if ( ! $field.is( ':checked' ) ) {
					return a;
				}

				value = 1;
			} else {
				value = $field.val();
			}

			let name = $field.attr( 'name' );

			if ( -1 !== name.indexOf( '[' ) ) {
				// if name is composite, try to recreate missing structure
				const components = name
						.split( '[' )
						.map( ( c ) => c.replace( /[\[, \]]/g, '' ) ),
					firstComponent = components.shift(),
					newItem = components
						.reverse()
						.reduce( ( res, key ) => ( { [ key ]: res } ), value );

				if ( 'undefined' === typeof data[ firstComponent ] ) {
					data[ firstComponent ] = newItem;
				} else {
					data[ firstComponent ] = $.extend(
						true,
						data[ firstComponent ],
						newItem
					);
				}
			} else {
				// else simply append value to result object
				data[ name ] = value;
			}

			return a;
		}, data );

		return data;
	}

	// modal level errors

	showErrorMessage( message ) {
		const $content = this.modal.elements.content,
			$error = $( '<div/>', {
				class: 'error-message form-row',
				text: message,
			} );

		this.hideErrorMessage();

		$content.prepend( $error );
		$error.get( 0 ).scrollIntoView();
	}

	hideErrorMessage() {
		const $content = this.modal.elements.content;

		$content.children( '.error-message' ).remove();
	}
}
